export default "__VITE_ASSET__CtLIeuVZ__"